import React, {useEffect, useState} from 'react';
import {UseFormReturn, useWatch} from "react-hook-form";
import {FormOperacionCapitalMarketsDetalle, OperacionCapitalMarketsDetalle} from "../types/types";
import {EntityWithIdAndDescription, EntityWithIdAndDescriptionFields} from "../../../../../types";
import {OperacionCapitalMarketsDetalleFields} from "../types/fields";
import {AsyncSelect, ControlledTextField} from "../../../../../components/forms";
import {Box, IconButton, Stack, Tooltip} from "@mui/material";
import Icon from "../../../../../@core/components/icon";

interface CapitalMarketsDetalleCampoTransaccionProps {
  formMethods: UseFormReturn<FormOperacionCapitalMarketsDetalle>,
  getOpciones: () => Promise<EntityWithIdAndDescription[]>
}

function CapitalMarketsDetalleCampoTransaccion({formMethods, getOpciones}: CapitalMarketsDetalleCampoTransaccionProps) {
  const [freeSolo, setFreeSolo] = useState<boolean>(false);

  const watchTransaccionTipo = useWatch({
    control: formMethods.control,
    name: OperacionCapitalMarketsDetalleFields.Transaccion
  })

  useEffect(() => {
    if (watchTransaccionTipo === null) {
      setFreeSolo(true)
    }
  }, [watchTransaccionTipo])

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='nowrap'>
      {
        !freeSolo ?
          <AsyncSelect loadOptions={getOpciones}
                       control={formMethods.control}
                       name={OperacionCapitalMarketsDetalleFields.Transaccion}
                       label='Transacción'
                       valueField={EntityWithIdAndDescriptionFields.Description}
                       nullOptionLabel={'Otro'}
                       fullWidth
          /> :
          <Stack direction={'row'}>
            <ControlledTextField
              control={formMethods.control}
              name={OperacionCapitalMarketsDetalleFields.Transaccion}
              label='Transacción'
              fullWidth
            />
            <Tooltip title='Ver opciones'>
              <IconButton onClick={() => {
                setFreeSolo(false)
              }}>
                <Icon icon={'mdi:menu'}/>
              </IconButton>
            </Tooltip>
          </Stack>
      }
    </Box>
  );
}

export default CapitalMarketsDetalleCampoTransaccion;